// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"CompanyLogo_companyLogo__3V_mF","companyLogoSmall":"CompanyLogo_companyLogoSmall__2ACB2","companyLogoBig":"CompanyLogo_companyLogoBig__1aQ-J"};